import { PaginationState } from "@tanstack/react-table";
import BreadCrumb from "Common/BreadCrumb";
import TableContainer from "Common/TableContainer";
import callApi from "Common/utils/apiCaller";
import {
  Contact,
  Download,
  Plus,
  Search,
  SlidersHorizontal,
  X,
} from "lucide-react";
import moment from "moment";
// import { Audio, TailSpin } from "react-loader-spinner";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import { Pencil, Trash2 } from "lucide-react";
import _ from "lodash";
import DeleteModal from "Common/DeleteModal";
import Modal from "Common/Components/Modal";
import * as Yup from "yup";
import { useFormik } from "formik";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import Drawer from "Common/Components/Drawer";
import PermissionSwitch from "Common/Components/PermissionLocks/PermissionSwitch";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { showNotification } from "Common/utils/Notification";
import eye from "../../assets/images/eye.svg";
import closeEye from "../../assets/images/eyeclose.svg";
import { validateName, validatePhoneNumber } from "Common/utils/Validation";
import Tab from "Common/Components/Tab/Tab";
import { Nav } from "Common/Components/Tab/Nav";
import ReactSelect from "Common/Components/ReactSelect/ReactSelect";
import LoaderComponent from "Common/Components/Loader/Loader";
import { nanoid } from "@reduxjs/toolkit";

const Admins = () => {
  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      permission: profile.permission,
      userId: profile.user,
    })
  );

  const { permission, userId } = useSelector(selectProperties);

  document.title = "Admin | Indxx";
  const [loader, setLoader] = useState(false);
  const [adminName, setAdminName] = useState("");
  const [nameErrors, setNameErrors] = useState("");
  const [search, setSearch] = useState("");
  const [roleData, setRoleData] = useState([]);
  const [isPasswordVisible, setPasswordVisibility] = useState(false);
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState<any>("");
  const [phone, setPhone] = useState<any>("");
  const [isPassword, setIsPassword] = useState(true);
  const [adminData, setAdminData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [eventData, setEventData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [roleId, setRoleId] = useState<any>("");
  const [role, setRole] = useState<any>("");
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [totalItems, setTotalItems] = useState(0);
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 30,
  });
  const [selectedImage, setSelectedImage] = useState<any>();
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);

  const togglePassword = () => {
    setPasswordVisibility(!isPasswordVisible);
  };

  const debouncedHandler = useCallback(
    _.debounce((search: string, pagination: any, isLoading: any) => {
      return fetchDateWithFilters(search, pagination, isLoading);
    }, 700),
    []
  );

  async function fetchDateWithFilters(
    searchByName: any,
    pagination: any,
    isLoading: any
  ) {
    let filters: { [index: string]: any } = {};
    if (searchByName) {
      filters.qtext = searchByName;
    }
    setLoader(true);
    const localData = await callApi("v1/admin/list", "post", {
      pageNum: pagination.pageIndex + 1,
      pageSize: pagination.pageSize,
      filters,
    });
    setLoader(false);
    if (localData?.status === "Success") {
      setAdminData(localData.data.adminList);
      setPageCount(Math.ceil(localData.data.adminCount / pagination.pageSize));
      setTotalItems(localData.data.adminCount);
    }
  }

  useEffect(() => {
    fetchRoleList();
  }, []);

  const fetchRoleList = async () => {
    const localData = await callApi("v1/role/list", "post", {
      pageNum: pagination.pageIndex + 1,
      pageSize: pagination.pageSize,
    });
    if (localData?.status === "Success") {
      setRoleData(
        localData.data.roleList.map((item) => ({
          label: item?.name,
          value: item?._id,
        }))
      );
    }
  };

  const filterSearchData = (e: any) => {
    const search = e.target.value;
    const keysToSearch = ["name", "designation", "location", "email", "status"];
    setSearch(search);
  };
  useEffect(() => {
    debouncedHandler(search, pagination, isLoading);
  }, [search, pagination, isLoading]);
  const options = [
    { value: "Select...", label: "Select Status" },
    { value: "Verified", label: "Verified" },
    { value: "Waiting", label: "Waiting" },
    { value: "Rejected", label: "Rejected" },
    { value: "Hidden", label: "Hidden" },
  ];

  const handleChange = (selectedOption: any) => {
    if (selectedOption.value === "Select...") {
      // setUser(userList);
    } else {
      const filteredUsers = adminData.filter(
        (data: any) => data.status === selectedOption.value
      );
      // setUser(filteredUsers);
    }
  };
  const handleRoleChange = (keyName: string, option: any) => {
    if (option.value === "Select...") {
      setRoleId("");
    } else {
      setRoleId(option.value);
    }
    setRole(option);
  };
  const handleSaveRole = async () => {
    setLoader(true);
    try {
      const res = await callApi(
        `v1/admin/${eventData?._id}/roles/${roleId}/attach-role`,
        "post",
        {}
      );
      setLoader(false);
      if (res && res?.status === "Success") {
        showNotification("Role Updated Successfully", "success");
        setIsLoading(!isLoading);
      }
    } catch (e) {
      showNotification("something went wrong", "error");
    }
  };
  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell._id) {
      setEventData(cell);
    }
  };

  const handleDelete = async () => {
    if (eventData) {
      //dispatch(onDeleteEmployee(eventData.id));
      setLoader(true);
      try {
        const res = await callApi(`v1/admin/${eventData?._id}/update`, "post", {
          admin: { is_deleted: true },
        });
        setLoader(false);
        if (res && res?.status === "Success") {
          setDeleteModal(false);
          setIsLoading(!isLoading);
          toast("Removed successfully");
        } else {
          toast(res.data.error);
        }
      } catch (e) {
        toast("something went wrong");
      }
    }
  };
  //

  // Update Data
  const handleUpdateDataClick = (ele: any) => {
    setEventData({ ...ele });
    setPassword("");
    setAdminName(ele?.contact_name);
    setPhone(ele?.contact_phone);
    setIsEdit(true);
    setShow(true);
  };

  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      // employeeId: (eventData && eventData.employeeId) || "",

      contact_email: (eventData && eventData.contact_email) || "",

      // password: (eventData && eventData.password) || "",
      gender: (eventData && eventData.gender) || "",
    },
    validationSchema: Yup.object({
      gender: Yup.string().required("Please enter gender"),
      // password: Yup.string().required("Please enter password"),
      contact_email: Yup.string().required("Please enter email"),
    }),
    onSubmit: async (values) => {
      if (isEdit) {
        const updateData = {
          _id: eventData ? eventData._id : 0,
          ...values,
        };
        if (!validatePhoneNumber(phone) || phone === "") {
          setErrors("Please enter a valid phone no.");
          // showNotification("Please enter valid phone no.", "error");
          return;
        } else {
          setErrors("");
        }
        // update user
        try {
          setLoader(true);
          const res = await callApi(
            `v1/admin/${eventData?._id}/update`,
            "post",
            {
              admin: {
                ...values,
                contact_name: adminName,
                // contact_name: values?.contact_name,
                // contact_email: values?.contact_email,
                contact_phone: phone,
                // gender: values?.gender,
              },
            }
          );
          setLoader(false);
          if (res && res?.status === "Success") {
            setIsLoading(!isLoading);
            showNotification("Updated successfully", "success");
          } else {
          }
        } catch (e) {
          setLoader(false);
          showNotification(e.response.data.data.message, "error");
        }
      } else {
        if (!password || password === "") {
          showNotification("Please enter password", "error");
          return;
        }
        if (!validateName(adminName) || adminName === "") {
          setNameErrors("Please enter a name");
          // showNotification("Please enter valid phone no.", "error");
          return;
        } else {
          setNameErrors("");
        }
        if (!validatePhoneNumber(phone) || phone === "") {
          setErrors("Please enter a valid phone no.");
          // showNotification("Please enter valid phone no.", "error");
          return;
        } else {
          setErrors("");
        }
        try {
          setLoader(true);
          const res = await callApi(`v1/admin/signup`, "post", {
            admin: {
              contact_name: adminName,
              password: password,
              contact_email: values?.contact_email,
              gender: values?.gender,
              contact_phone: phone,
              country_code: "91",
            },
          });
          setLoader(false);
          if (res && res?.status === "Success") {
            setIsLoading(!isLoading);
            showNotification("User created successfully", "success");
            setPassword("");
          }
        } catch (e) {
          setLoader(false);
          showNotification(e.response.data.data.message, "error");
        }
      }
      toggle();
    },
  });
  // useEffect(() => {
  //   if (!validatePhoneNumber(phone) && phone !== "") {
  //     setErrors("Please enter a valid phone no.");
  //     return;
  //   } else {
  //     setErrors("");
  //   }
  // }, [phone]);
  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      setIsEdit(false);
      setSelectedImage("");
      setAdminName("");
      setPhone("");
      setPassword("");
    } else {
      setShow(true);
      setEventData("");
      setAdminName("");
      setPassword("");
      setPhone("");
      setSelectedImage("");
      validation.resetForm();
    }
  }, [show, validation]);

  const adminListColumns = useMemo(
    () => [
      {
        header: "Name",
        accessorKey: "contact_name",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Email",
        accessorKey: "contact_email",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Phone",
        accessorKey: "contact_phone",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Role",
        accessorKey: "role.name",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <PermissionSwitch
              hasPermissions={permission.permissions}
              shouldHavePermissions={["admin:edit"]}
              yes={
                <Link
                  to="#!"
                  data-modal-target="addEmployeeModal"
                  className="flex items-center justify-center transition-all duration-200 ease-linear rounded-md size-8 edit-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                  onClick={() => {
                    const data = cell.row.original;
                    handleUpdateDataClick(data);
                  }}
                >
                  <Pencil className="size-4" />
                </Link>
              }
              no={<span></span>}
            />
            <PermissionSwitch
              hasPermissions={permission.permissions}
              shouldHavePermissions={["admin:delete"]}
              yes={
                <Link
                  to="#!"
                  className="flex items-center justify-center transition-all duration-200 ease-linear rounded-md size-8 remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                  onClick={() => {
                    const data = cell.row.original;
                    onClickDelete(data);
                  }}
                >
                  <Trash2 className="size-4" />
                </Link>
              }
              no={<span></span>}
            />
          </div>
        ),
      },
    ],
    [permission.permissions]
  );

  return (
      <PermissionSwitch
       hasPermissions={permission.permissions}
       shouldHavePermissions={["admin:read"]}
       yes={
    <React.Fragment>
      <BreadCrumb title="Admins" pageTitle="Admins" version="" />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer closeButton={false} limit={1} />
      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 card 2xl:col-span-12">
          <div className="card-body">
            <div className="flex items-center">
              <h6 className="text-15 grow">Admins</h6>
              <div className="shrink-0">
                <PermissionSwitch
                  hasPermissions={permission.permissions}
                  shouldHavePermissions={["admin:create"]}
                  yes={
                    <button
                      type="button"
                      className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      onClick={toggle}
                    >
                      <Plus className="inline-block size-4" />{" "}
                      <span className="align-middle">Add Admin</span>
                    </button>
                  }
                  no={
                    <button
                      type="button"
                      disabled={true}
                      className="text-grey btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      onClick={null}
                    >
                      <Plus className="inline-block size-4" />{" "}
                      <span className="align-middle">Add Admin</span>
                    </button>
                  }
                />
              </div>
            </div>
          </div>
          <div className="!py-3.5 card-body border-y border-dashed border-slate-200 dark:border-zink-500">
            <form action="#!">
              <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
                <div className="relative xl:col-span-3">
                  <input
                    type="text"
                    className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Search for name, email etc..."
                    autoComplete="off"
                    onChange={(e) => filterSearchData(e)}
                  />
                  <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
                </div>
              </div>
            </form>
          </div>
          <div className="card-body">
            <TableContainer
              isPagination={true}
              columns={adminListColumns || []}
              data={adminData || []}
              pageCount={pageCount}
              pagination={pagination}
              totalItems={totalItems}
              onPaginationChange={(updater: any) => {
                const nextState = updater(pagination);
                if (nextState.pageIndex !== pagination.pageIndex)
                  setPagination(nextState);
              }}
              divclassName="overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 text-slate-500 dark:text-zink-200 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-y border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
            />
          </div>
        </div>
      </div>
      {/* Employee Modal */}
      <Drawer
        show={show}
        onHide={toggle}
        id="defaultModal"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">
            {!!isEdit ? "Edit Admin" : "Add Admin"}
          </Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <Tab.Container defaultActiveKey="details">
            <Nav className="flex flex-wrap w-full text-sm font-medium text-center border-b border-slate-200 dark:border-zink-500 nav-tabs">
              <Nav.Item eventKey="details" className="group grow">
                <a
                  href="#!"
                  data-tab-toggle
                  data-target="details"
                  className="inline-block px-4 py-2 text-base w-full transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border border-transparent group-[.active]:text-custom-500 group-[.active]:border-slate-200 dark:group-[.active]:border-zink-500 group-[.active]:border-b-white dark:group-[.active]:border-b-zink-700 hover:text-custom-500 active:text-custom-500 dark:hover:text-custom-500 dark:active:text-custom-500 dark:group-[.active]:hover:text-white -mb-[1px]"
                >
                  {!!isEdit ? "Edit Admin" : "Add Admin"}
                </a>
              </Nav.Item>
              {!!isEdit ? (
                <Nav.Item eventKey="apicalls" className="group grow">
                  <a
                    href="#!"
                    data-tab-toggle
                    data-target="apicalls"
                    className="inline-block px-4 py-2 text-base w-full transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border border-transparent group-[.active]:text-custom-500 group-[.active]:border-slate-200 dark:group-[.active]:border-zink-500 group-[.active]:border-b-white dark:group-[.active]:border-b-zink-700 hover:text-custom-500 active:text-custom-500 dark:hover:text-custom-500 dark:active:text-custom-500 dark:group-[.active]:hover:text-white -mb-[1px]"
                  >
                    Edit Role
                  </a>
                </Nav.Item>
              ) : null}
            </Nav>

            <Tab.Content className="mt-5 tab-content">
              <Tab.Pane eventKey="details" id="details">
                <form
                  className="create-form"
                  id="create-form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  <input type="hidden" value="" name="id" id="id" />
                  <input type="hidden" value="add" name="action" id="action" />
                  <input type="hidden" id="id-field" />
                  <div
                    id="alert-error-msg"
                    className="hidden px-4 py-3 text-sm text-red-500 border border-transparent rounded-md bg-red-50 dark:bg-red-500/20"
                  ></div>
                  <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                    <div className="xl:col-span-12">
                      <label
                        htmlFor="contact_name"
                        className="inline-block mb-2 text-base font-medium"
                      >
                        Name
                      </label>
                      <input
                        type="text"
                        id="contact_name"
                        className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        placeholder="Enter First Name"
                        onChange={(e) => {
                          setAdminName(e.target.value);

                          setNameErrors("");
                        }}
                        value={adminName || ""}
                      />
                      {nameErrors && nameErrors ? (
                        <p className="text-red-400">{nameErrors}</p>
                      ) : null}
                    </div>

                    <div className="xl:col-span-12">
                      <label
                        htmlFor="contact_phone"
                        className="inline-block mb-2 text-base font-medium"
                      >
                        Phone Number
                      </label>
                      <input
                        type="text"
                        id="contact_phone"
                        className="form-input border-slate-200 focus:outline-none dark:border-zink-500 focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        placeholder="Phone Number"
                        onChange={(e) => {
                          setPhone(e.target.value);

                          setErrors("");
                        }}
                        value={phone || ""}
                      />
                      {errors && errors ? (
                        <p className="text-red-400">{errors}</p>
                      ) : null}
                    </div>
                    <div className="xl:col-span-12">
                      <label
                        htmlFor="contact_email"
                        className="inline-block mb-2 text-base font-medium"
                      >
                        Email
                      </label>
                      <input
                        type="email"
                        id="contact_email"
                        className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        placeholder="Enter Email "
                        name="contact_email"
                        onChange={validation.handleChange}
                        value={validation.values.contact_email || ""}
                      />
                      {validation.touched.contact_email &&
                      validation.errors.contact_email ? (
                        <p className="text-red-400">
                          {validation.errors.contact_email}
                        </p>
                      ) : null}
                    </div>
                    {!!isEdit ? null : (
                      <div className="xl:col-span-12">
                        <label
                          htmlFor="password7"
                          className="inline-block mb-2 text-base font-medium"
                        >
                          <span>Password</span>{" "}
                        </label>
                        <div className="flex items-center">
                          <input
                            type={isPasswordVisible ? "text" : "password"}
                            id="password7"
                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                            placeholder="Enter Password "
                            // name="password"
                            onChange={(e) => {
                              setPassword(e.target.value);
                            }}
                            value={password || ""}
                            autoComplete="new-password"
                          />

                          <img
                            src={!isPasswordVisible ? closeEye : eye}
                            alt="img"
                            onClick={togglePassword}
                            className="w-12 h-12 py-1 cursor-pointer border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                          />
                        </div>
                      </div>
                    )}
                    <div className="xl:col-span-6">
                      <label
                        htmlFor="statusgender"
                        className="inline-block mb-2 text-base font-medium"
                      >
                        Gender
                      </label>
                      <select
                        onChange={validation.handleChange}
                        value={validation.values.gender || ""}
                        name="gender"
                        id="statusgender"
                        className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      >
                        <option value={""}>Select</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                      </select>
                      {validation.touched?.gender &&
                      validation.errors?.gender ? (
                        <div className="mt-1 text-sm text-red-500">
                          {validation.errors?.gender}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="flex justify-end gap-2 mt-4">
                    <button
                      type="reset"
                      id="close-modal"
                      data-modal-close="addEmployeeModal"
                      className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                      onClick={toggle}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      id="addNew"
                      disabled={loader}
                      style={{
                        minWidth: "130px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                      className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                    >
                      {loader ? (
                        <LoaderComponent />
                      ) : !!isEdit ? (
                        "Update Admin"
                      ) : (
                        "Add Admin"
                      )}
                    </button>
                  </div>
                </form>
              </Tab.Pane>
              <Tab.Pane eventKey="apicalls" id="apicalls">
                <ReactSelect
                  options={roleData}
                  isSearchable={true}
                  isMulti={false}
                  placeholder={"Please select Role"}
                  contentType={role}
                  handleContentChange={handleRoleChange}
                  name={"role"}
                  id={"content-type1"}
                />
                <div className="flex justify-end gap-2 mt-4">
                  <button
                    type="reset"
                    id="close-modal"
                    data-modal-close="addEmployeeModal"
                    className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                    onClick={toggle}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => handleSaveRole()}
                    type="submit"
                    id="addNew2"
                    disabled={loader || !role}
                    style={{
                      minWidth: "130px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                    className={`text-white btn bg-custom-500 border-custom-500
                    hover:text-white hover:bg-custom-600 hover:border-custom-600
                    focus:text-white focus:bg-custom-600 focus:border-custom-600
                      focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600
                    active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20
                      ${loader || !role ? "pointer-events-none opacity-50" : ""}
                     `}                  >
                    {loader ? <LoaderComponent /> : "Save"}
                  </button>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Drawer.Body>
      </Drawer>
    </React.Fragment>
    }
    no={
      <div className="text-center mt-10 text-gray-500">
        You do not have permission to view Admin List.
      </div>
    }
  />
  );
};

export default Admins;
